import React from 'react';
import {
  Grid,
  TextField,
  Typography,
  Box,
  Divider
} from '@mui/material';

const PersonalInfoTab = ({ personal, onUpdate }) => {
  const handleChange = (field) => (event) => {
    onUpdate({ [field]: event.target.value });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Personal Information
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Full Name"
            value={personal?.name || ''}
            onChange={handleChange('name')}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Email"
            type="email"
            value={personal?.email || ''}
            onChange={handleChange('email')}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Phone"
            type="tel"
            value={personal?.phone || ''}
            onChange={handleChange('phone')}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Address"
            value={personal?.address || ''}
            onChange={handleChange('address')}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
            Online Profiles
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="LinkedIn"
            value={personal?.linkedin || ''}
            onChange={handleChange('linkedin')}
            variant="outlined"
            placeholder="linkedin.com/in/username"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="GitHub"
            value={personal?.github || ''}
            onChange={handleChange('github')}
            variant="outlined"
            placeholder="github.com/username"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Portfolio"
            value={personal?.portfolio || ''}
            onChange={handleChange('portfolio')}
            variant="outlined"
            placeholder="https://myportfolio.com"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Website"
            value={personal?.website || ''}
            onChange={handleChange('website')}
            variant="outlined"
            placeholder="https://mywebsite.com"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PersonalInfoTab;
